import type { GridColDef } from '@mui/x-data-grid';

import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { dateUtils } from '@/utils/date';

export const columns = (): GridColDef[] => [
    {
        field: 'code',
        headerName: 'Mã',
        minWidth: 200,
        flex: 1,
        sortable: false,
        renderCell: params => <HoverCopyCell value={params.row.code} />,
    },
    {
        field: 'name',
        headerName: 'Tên danh mục thành phần',
        minWidth: 300,
        editable: false,
        sortable: false,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.row.name} />,
    },
    {
        field: 'description',
        headerName: 'Mô tả',
        minWidth: 300,
        editable: false,
        sortable: false,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.row.description} />,
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        editable: false,
        sortable: true,
        minWidth: 150,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell
                value={
                    params.row.createdDate
                        ? dateUtils.getDate(params.row.createdDate)
                        : '-:-'
                }
            />
        ),
    },
];
